import { en, zh } from '@formkit/i18n'

export default {
  locales: { en, zh },
  locale: 'en'
}
